import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const QuizProgress = ({ currentIndex, total }) => {
  // Align with "Question N of M" (not 0-based). On the final question, stay short of 100% so it
  // doesn’t read as “already finished” before they pick an answer.
  let ratio = 0;
  if (total > 0) {
    if (total > 1 && currentIndex >= total - 1) {
      ratio = (total - 0.5) / total;
    } else {
      ratio = Math.min(currentIndex + 1, total) / total;
    }
  }
  const pct = Math.round(ratio * 10000) / 100;
  return (
    <div className="quiz-progress">
      <div className="d-flex justify-content-center align-items-center flex-wrap gap-2 mb-2 quiz-progress-labels">
        <span>
          Question {Math.min(currentIndex + 1, total)} of {total}
        </span>
        <span aria-hidden="true">·</span>
        <span>{Math.round(pct)}%</span>
      </div>
      <ProgressBar now={pct} className="quiz-progress-bar" />
    </div>
  );
};

export default QuizProgress;
